<template>
	<b-row>
        <b-col cols="12">
            <search-view :click-search="getInstallations"/>
        </b-col>

        <b-col cols="12">
			<b-card title="">
				<b-overlay
					variant="white"
					:show="showLoading"
					spinner-variant="primary"
					blur="0"
					opacity=".75"
					rounded="sm"
				>
					<div class="ml-1 mb-2">
						<b-row>
							<b-col cols="12" md="9"
								   class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
							>
								<label>Mostrar</label>
								<v-select
									v-model="pageLength"
									:dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
									:options="['3','5','10','20']"
									:clearable="false"
									class="per-page-selector d-inline-block mx-50"
									@input="changeLength"
								/>
								<b-button v-if="can('create_gei_master')" variant="primary" @click="goToCreate()">
									Añadir nueva Instalación GEI
								</b-button>
							</b-col>
						</b-row>
					</div>

					<b-table
						ref="refUserListTable"
						class="position-relative table-size-list"
            :tbody-tr-class="rowClass"
            :items="masters_installations"
						responsive
            striped
            sticky-header
						:fields="columns"
						primary-key="id"
						show-empty
						empty-text="No hay registros"
            @row-clicked="handleRowClick"
          >
                        <template #cell(name)="data">
                            <router-link :to="{ name: 'users_edit', params: { id: data.item.id} }">
                                {{ data.item.name }}
                            </router-link>
                        </template>

                        <template #cell(company)="data">
                            {{ data.item.company ? data.item.company.name : null }}
                        </template>

                        <template #cell(date_start)="data">
                            {{ data.item.start_date ? helpers.formatDate(data.item.start_date) : null }}
                        </template>

                        <template #cell(date_end)="data">
                            {{ data.item.end_date ? helpers.formatDate(data.item.end_date) : null }}
                        </template>

                        <template #cell(active)="data">
                            <b-badge :variant="data.value === 1 ? 'success' : 'danger'">
                                {{ data.value === 1 ? 'Si' : 'No' }}
                            </b-badge>
                        </template>

						<template #cell(actions)="data" class="col-sm-2">
								<div @click.stop>
                  <router-link :to="{ name: 'installations_gei_edit', params: { id: data.item.id} }">
                    <feather-icon
                        v-if="can('Dashboard')"
                        :id="`invoice-row-${data.item.id}-send-icon`"
                        icon="EditIcon"
                        class="cursor-pointer"
                        size="16"
                    />

                  </router-link>

                  <feather-icon
                      v-if="can('delete_gei_master')"
                      :id="`invoice-row-${data.item.id}-preview-icon`"
                      icon="TrashIcon"
                      size="16"
                      class="cursor-pointer ml-1 text-red"
                      @click="deleteMasterInstallation(data.item.id)"
                  />
                  <b-tooltip
                      title="Eliminar Instalación"
                      :target="`invoice-row-${data.item.id}-preview-icon`"
                  />
                </div>
						</template>
					</b-table>

					<div class="mx-2 mb-2">
						<b-row>
							<b-col
								cols="12"
								sm="6"
								class="d-flex align-items-center justify-content-center justify-content-sm-start"
							>
								<span class="text-muted">Mostrando {{ pageLength }} de {{ totalRecords }} Instalaciones</span>
							</b-col>

							<b-col
								cols="12"
								sm="6"
								class="d-flex align-items-center justify-content-center justify-content-sm-end"
							>
								<b-pagination
									:value="1"
									:total-rows="totalRecords"
									:per-page="pageLength"
									first-number
									last-number
									align="right"
									prev-class="prev-item"
									next-class="next-item"
									class="mt-1 mb-0"
									@input="changePage"
								>
									<template #prev-text>
										<feather-icon
											icon="ChevronLeftIcon"
											size="18"
										/>
									</template>
									<template #next-text>
										<feather-icon
											icon="ChevronRightIcon"
											size="18"
										/>
									</template>
								</b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-overlay>
			</b-card>
		</b-col>
	</b-row>
</template>

<script>
import {BRow, BCol, BTable, BCard, BButton, BTooltip, BPagination, BOverlay, BBadge} from 'bootstrap-vue'
import vSelect from "vue-select"
import {mapState} from "vuex"
import Swal from "sweetalert2"
import {GEI_MASTERS_INSTALLATIONS_CREATE} from "@/router/web/constants"
import helpers from "@/resources/helpers/helpers"
import SearchView from "@/views/gei/masters_installations/list/components/searchView"
import helper from "@/resources/helpers/helpers"
import authService from "@/services/auth/authService"

export default {
	name: "ListView",
	components: {
		BRow,
		BCol,
		BTable,
		BCard,
		BButton,
		BTooltip,
		BPagination,
		BOverlay,
    BBadge,

		vSelect,
    SearchView
	},
	data() {
		return {
			page: 1,
			pageLength: 10,
			totalRecords: 10,
			columns: [
                {key: 'actions', label: 'Acciones', sortable: false},
                {key: 'installation_code', label: 'Nombre', sortable: false},
                {key: 'client', label: 'Cliente', sortable: false},
                {key: 'company', label: 'Empresa', sortable: false},
                {key: 'date_start', label: 'Fecha inicio explotación', sortable: false},
                {key: 'date_end', label: 'Fecha fin explotación', sortable: false},
                {key: 'active', label: 'Activa', sortable: false},
			],
			searchTerm: '',
			showLoading: false,
            helpers
		}
	},
	computed: {
		...mapState('masterInstallation', ['masters_installations', 'search']),
	},
	created() {
    this.setUserCompanies()
    this.getInstallations()
	},
	methods: {
		can(permission) {
			return this.$store.getters.can(permission)
		},
		formatDate(date) {
			const dateFormated = new Date(date)

			return dateFormated.toLocaleDateString("es-ES")
		},
    setUserCompanies() {
      const userCompanies = this.$store.state.AppActiveUser.companies
      this.search.companies = userCompanies.map(company => company.id)
    },
		getInstallations() {
			this.showLoading = true
      let filteredSearch = JSON.parse(JSON.stringify(this.search))

      if (!filteredSearch.companies || filteredSearch.companies.length < 1){
        const userCompanies = this.$store.state.AppActiveUser.companies
        filteredSearch.companies = userCompanies.map(company => company.id)
      }
			this.$store.dispatch('masterInstallation/searchMasterInstallations', {
				relations: [ 'company' ],
				per_page: this.pageLength,
				page: this.page,
        filter: filteredSearch,
			})
				.then(response => {
					this.showLoading = false
					this.totalRecords = response.total_records
				})
				.catch(error => {
					this.showLoading = false
					console.log(error)
				})
		},
		deleteMasterInstallation(id) {
			Swal.fire({
                title: "Estás seguro que quieres eliminar la instalación?",
                text: "Una vez borrada no se podra recuperar!",
                icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#34c38f",
				cancelButtonColor: "#f46a6a",
				confirmButtonText: "¡Sí, borralo!",
				cancelButtonText: "Cancelar",
			}).then(result => {
				if (result.value) {
					this.$store.dispatch('masterInstallation/deleteMasterInstallation', {id: id})
						.then(response => {
							this.showLoading = false
                            helper.showToast('Instalación eliminada correctamente!', 'CheckIcon', 'success')
							this.getInstallations()
						})
						.catch(error => {
							this.showLoading = false
                            helper.showToast('Error al eliminar la instalación', 'AlertOctagonIcon', 'danger')
                            console.log(error)
						})
				}
			})
		},
		changePage(page) {
            this.page = page
			this.getInstallations()
		},
		changeLength(length) {
            this.length = length
			this.getInstallations()
		},
		searchUser() {
			this.getInstallations()
		},
		goToCreate(){
			this.$router.push(GEI_MASTERS_INSTALLATIONS_CREATE)
		},
    handleRowClick(data) {
      this.$router.push({name: 'installations_gei_edit', params: {id: data.id}})
    },
    rowClass(item) {
      return item ? 'pointer' : ''
    }
	}
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.pointer {
  cursor: pointer !important;
}
</style>